<template>
  <div>
    <div class="field">
      <p v-if="pagerLoaded">
        {{ this.$t("pager.show") }} {{ info.from }} {{ this.$t("pager.to") }}
        {{ info.to }} {{ this.$t("pager.of") }} {{ info.total }}
        {{ this.$t("pager.total") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "volcan-pagination-info",
  props: ["data"],
  data() {
    return {
      info: {}
    };
  },
  mounted() {},
  watch: {},
  computed: {
    pagerLoaded() {
      return Object.keys(this.info).length > 0;
    }
  },
  methods: {
    setPaginationData(data) {
      this.info = data;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// components/AdminTools/dataTable/paginationInfo.vue